import { render, staticRenderFns } from "./video-slide.vue?vue&type=template&id=1c9d6bd7&scoped=true&"
import script from "./video-slide.vue?vue&type=script&lang=js&"
export * from "./video-slide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9d6bd7",
  null
  
)

export default component.exports